import { AppState } from 'types/appState';
import { createInvalidatedCacheFlags } from 'utils/createInvalidatedCacheFlags';
import { createPersonalInfoFormValues } from 'utils/createPersonalInfoFormValues';
import { createOrgInfoFormValues } from 'utils/createOrgInfoFormValues';
import { createPartnerManager } from 'utils/partnerManagerUtils';
import { createPartnerClientManager } from 'utils/partnerClientManagerUtils';
import { createPartnerDashboard } from 'utils/partnerDashboardUtils';
import { createGiroPaymentManager } from 'utils/giroPaymentManagerUtils';
import { createCardPaymentManager } from 'utils/cardPaymentManagerUtils';
import {
  createPrimitiveCache,
  createPrimitiveCacheConstructor,
} from './primitiveCache/primitiveCacheUtils';
import { AppEnvironment } from 'types/appEnvironment';

export const createAppState = (): AppState => ({
  invalidatedCacheFlags: createInvalidatedCacheFlags(),
  demoStackUrl: undefined,
  authType: null,
  user: null,
  prodStackInfo: undefined,
  prodStackManagerCurrentStep: 0,
  personalInfoFormValues: createPersonalInfoFormValues(),
  orgInfoFormValues: createOrgInfoFormValues(),
  partnerManager: createPartnerManager(),
  partnerClientManager: createPartnerClientManager(),
  partnerDashboard: createPartnerDashboard(),
  giroPaymentManager: createGiroPaymentManager(),
  cardPaymentManager: createCardPaymentManager(),
  environment: createPrimitiveCacheConstructor(
    createPrimitiveCache<AppEnvironment>('testing')
  )
    .invalidate()
    .get(),
});
